import React from 'react';

import {Card, Dropdown, Menu, MenuButton, Modal, ModalClose, ModalDialog, Stack} from "@mui/joy";
import Chip from "@mui/joy/Chip";
import IconButton from "@mui/joy/IconButton";
import Avatar from "@mui/joy/Avatar";
import Box from "@mui/joy/Box";

// components
import MessageContent from "./MessageContent";
import MessageActions from "./MessageActions";
import BaseApi from "../../utils/BaseApi";
import CommonForm from "../Common/CommonForm";
import UserSubscriberContext from "../../context/UserSubscriberContext";


// icons
import AddReaction from '@mui/icons-material/AddReaction';


class Message extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        let isMyMessage = this.props.message.owner?.id === this.props.subscriberObject.id
        this.state = {
            message: this.props.message,
            reactions: this.props.message.reactions,
            myReactions: this.props.message.my_reactions,
            isMyMessage: isMyMessage,
            isRead: isMyMessage || this.props.message.read_by.includes(this.props.subscriberObject.id),
            forwardModal: false,
            forwardForm: null,
        }
    }

    async setRead(){
        this.setState({
            isRead: true,
        })
        await this.props.readCallBack(this.props.message.id)
    }

    async setReaction(value){
        let myReactions = this.state.myReactions
        myReactions.push(value)
        this.setState({
            myReactions: myReactions,
        })
        await this.props.reactionCallBack(
            this.props.message.id,
            value
        )
    }

    async deleteReactionLocal(value){
        let myReactions = this.state.myReactions
        this.setState({
            myReactions: myReactions.filter(a => a !== value),
        })
        await this.props.deleteReactionCallBack(
            this.props.message.id,
            value
        )
    }

    async addReaction(value){
        let reactions = this.state.reactions
        if (reactions[value]){
            reactions[value] += 1;
        }
        else {
            reactions[value] = 1;
        }
        this.setState({
            reactions: reactions,
        })
    }

    async deleteReaction(value){
        let reactions = this.state.reactions
        if (reactions[value]){
            reactions[value] -= 1;
        }
        if (!reactions[value]){
            delete reactions[value]
        }
        this.setState({
            reactions: reactions,
        })
    }

    async deleteMessage(){
        const api = new BaseApi();
        let url = `message/${this.props.message.id}/`
        let response = await api.patch(
            url,
            {
                deleted: true,
            }
        );
        this.setState({
            message: response.data,
        })
    }

    markMessageDeleted(){
        let message = this.state.message
        message.deleted = true
        this.setState({
            message: message,
        })
    }

    async forwardModalOpen(){
        const url = 'room_subscriber/';
        const params = {
            subscriber: this.context.subscriberObject.id,
            page_size: 10000,
            archived: false,
        };
        const api = new BaseApi();
        let response = await api.get(
            url,
            params
        );
        this.setState({
            forwardForm: [
                {
                    name: 'room',
                    label: 'Чат',
                    xs: 12,
                    sm: null,
                    md: null,
                    lg: null,
                    xl: null,
                    required: true,
                    default: null,
                    type: 'select',
                    options: response.data.results.map(r => (
                        {
                            value: r.room.id,
                            label: r.room.xtype === 'ONETOONE' ? r.title.slice(0, 30) : r.room.title.slice(0, 30)
                        }
                    ))
                },
                {
                    name: 'content',
                    label: 'Комментарий',
                    required: false,
                    default: '',
                    xs: 12,
                    type: 'input',
                },
                {
                    type: 'submit',
                    label: 'Переслать',
                },
            ]
        }, () => {
            this.setState({
                forwardModal: true
            })
        })
    }

    async processForward(form){
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );

        const api = new BaseApi();
        const url = `message/${this.props.message.id}/forward/`
        let response = await api.post(
            url,
            formDataObj
        );
        this.forwardModalClose()
    }

    forwardModalClose(){
        this.setState({
            forwardModal: false
        })
    }

    render() {
        return(
            <Stack
                spacing={1}
                justifyContent={this.state.isMyMessage ? "flex-end" : "flex-start"}
                sx={{
                    width: '100%',
                }}
                onMouseEnter={() => {
                        if (!this.state.isMyMessage && !this.state.isRead) {
                            this.setRead.bind(this)()
                        }
                    }
                }
            >
                <Stack
                    spacing={1}
                >
                    <Stack
                        direction={this.state.isMyMessage ? "row-reverse" : "row"}
                        sx={{
                            alignItems: 'end'
                        }}
                        spacing={1}
                    >
                        {
                            !this.state.message.deleted ?
                                <Avatar
                                    key={'SubscriberMessengerAvatar' + this.props.message.id}
                                    src={`data:image/jpeg;base64,${this.props.avatars[this.state.message.owner?.id]}`}
                                    size="sm"
                                />:
                                null
                        }
                        {
                            this.state.message.deleted?
                                <Card
                                    size={'sm'}
                                    variant={'soft'}
                                    color={'warning'}
                                >
                                    Сообщение удалено
                                </Card>:
                                <Card
                                    size={'sm'}
                                    variant={this.state.isRead ? 'soft' : 'solid'}
                                    color={this.state.isMyMessage ? 'primary' : this.state.isRead ? 'neutral' : 'warning'}
                                    sx={{
                                        maxWidth: '70%',
                                        borderRadius: this.state.isMyMessage
                                            ? '16px 16px 0px 16px;'
                                            : '16px 16px 16px 0px;'
                                    }}
                                    id={'MessageCard'+this.state.message.id}
                                >
                                    {this.state.message.forwarded_from ? <Chip size={'sm'} color={'warning'}>Переслано</Chip> : null}
                                    <MessageContent
                                        parser={this.props.parser}
                                        isMyMessage={this.state.isMyMessage}
                                        isRead={this.state.isRead}
                                        message={this.state.message}
                                        showReply={true}
                                        allowEdit={this.props.allowEdit}
                                    />
                                    <Stack
                                        direction={'row'}
                                        spacing={1}
                                        sx={{
                                            flexWrap: 'wrap',
                                        }}
                                        alignItems={'center'}
                                    >
                                        {
                                            Object.entries(this.state.reactions).map(reaction => (
                                                    <Chip
                                                        startDecorator={<div>{reaction[0]}</div>}
                                                        onClick={() => {
                                                            if (!this.state.myReactions.includes(reaction[0])){
                                                                this.setReaction.bind(this)(reaction[0])
                                                            }
                                                            else {
                                                                this.deleteReactionLocal.bind(this)(reaction[0])
                                                            }
                                                        }}
                                                        variant={this.state.myReactions.includes(reaction[0])?'solid':'plain'}
                                                        // color={this.state.myReactions.includes(reaction[0])?'warning':'neutral'}
                                                        size={'sm'}
                                                        key={'ReactionChip' + crypto.randomUUID()}
                                                    >
                                                        {reaction[1]}
                                                    </Chip>
                                                )
                                            )
                                        }
                                        <Stack
                                            direction={'row'}
                                            spacing={1}
                                        >
                                            <Dropdown
                                                key={'Dropdown' + crypto.randomUUID()}
                                            >
                                                <MenuButton
                                                    variant="plain"
                                                    size="sm"
                                                >
                                                    <AddReaction />
                                                </MenuButton>
                                                <Menu
                                                    variant="soft"
                                                    size="sm"
                                                    sx={{
                                                        width: '200px',
                                                        display: 'flex',
                                                        flexFlow: 'row wrap',
                                                    }}
                                                >
                                                    {this.props.emojis.filter(item => !this.state.myReactions.includes(item)).map(e => (
                                                        <IconButton
                                                            variant="plain"
                                                            color="neutral"
                                                            onClick={() => {
                                                                this.setReaction.bind(this)(e)
                                                            }}
                                                            key={'IconButton' + crypto.randomUUID()}
                                                        >
                                                            {e}
                                                        </IconButton>
                                                    ))}
                                                </Menu>
                                            </Dropdown>
                                        </Stack>
                                        <i>{this.state.message.created_on}</i> {this.state.message.read_by.length > 1?'✓️':''}
                                    </Stack>
                                </Card>
                        }
                        {
                            !this.state.message.deleted?
                                <MessageActions
                                    replyCallBack={this.props.replyCallBack}
                                    message={this.state.message}
                                    deleteCallBack={this.deleteMessage.bind(this)}
                                    isMyMessage={this.state.isMyMessage}
                                    forwardCallBack={this.forwardModalOpen.bind(this)}
                                />:null
                        }
                    </Stack>
                </Stack>
                <Modal
                    open={this.state.forwardModal}
                >
                    <ModalDialog
                        layout={'center'}
                        size="sm"
                    >
                        <ModalClose
                            onClick={this.forwardModalClose.bind(this)}
                        />
                        <Box
                            sx={{
                                width: 'calc(80vw)',
                                pr: 2
                            }}
                        >
                            <CommonForm
                                fields={this.state.forwardForm}
                                processForm={this.processForward.bind(this)}
                            />
                        </Box>
                    </ModalDialog>
                </Modal>
            </Stack>
        )
    }
}

export default Message
